function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { onKeyDown } from '../../utils/events';
import emitter from '../../utils/emitter';
import './styles';

var TextInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TextInput, _Component);

  function TextInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onEmittedFocus = _this.onEmittedFocus.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this)); // keyboard events

    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onEnterKey = _this.onEnterKey.bind(_assertThisInitialized(_this));
    _this.onSelection = _this.onSelection.bind(_assertThisInitialized(_this));
    _this.onOtherKey = _this.onOtherKey.bind(_assertThisInitialized(_this));
    _this.eventSubscriptions = [];

    _this.eventSubscriptions.push(emitter.addListener('focus', _this.onEmittedFocus));

    _this.eventSubscriptions.push(emitter.addListener('enterKey', _this.onEnterKey(emitter)));

    _this.eventSubscriptions.push(emitter.addListener('onSelection', _this.onSelection));

    _this.eventSubscriptions.push(emitter.addListener('otherKey', _this.onOtherKey));

    _this.input = /*#__PURE__*/React.createRef();
    _this.state = {
      focusedId: '',
      typedText: _this.props.defaultValue || ''
    };
    return _this;
  } // begin lifecycle methods


  var _proto = TextInput.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.eventSubscriptions.map(this.unsubscribe);
  } // end lifecycle methods
  ;

  _proto.unsubscribe = function unsubscribe(subscription) {
    subscription.remove();
  };

  _proto.onEmittedFocus = function onEmittedFocus(id) {
    this.setState({
      focusedId: id
    });
  };

  _proto.onEnterKey = function onEnterKey(emitterImpl) {
    var _this2 = this;

    return function () {
      emitterImpl.emit('identifySelection', _this2.state.focusedId);
    };
  };

  _proto.onOtherKey = function onOtherKey() {
    this.input.current.focus();
  };

  _proto.onFocus = function onFocus(e) {
    this.props.onFocus(e);
  };

  _proto.onChange = function onChange(e) {
    var typedText = e.target.value;
    var nextState = {
      typedText: typedText
    };

    if (typedText.length === 0) {
      nextState = _extends({}, nextState, {
        focusedId: null
      });
    }

    this.setState(nextState);
    this.props.onChange(typedText);
  };

  _proto.onSelection = function onSelection(value) {
    this.setState({
      focusedId: null,
      typedText: value.text
    });
    this.input.current.focus();
  } // begin keyboard events
  ;

  _proto.onKeyDown = function onKeyDown(onKeyDownImpl) {
    var _this3 = this;

    return function (ev) {
      // the onEnterKey handler above is specifically for tracking
      // selection state, so the enter key event specifically for the
      // <input> is handled here.  This could be cleaner…
      if (ev.which === 13) {
        _this3.props.onEnterKey();
      }

      onKeyDownImpl(_this3.props.menuOpen, ev);
    };
  } // end keyboard events
  ;

  _proto.render = function render() {
    var typedText = this.state.typedText;
    var _this$props = this.props,
        label = _this$props.label,
        id = _this$props.id;
    return /*#__PURE__*/React.createElement("input", {
      "aria-label": label,
      className: "typeahead-input fds-field-input",
      onChange: this.onChange,
      onFocus: this.onFocus,
      onKeyDown: this.onKeyDown(onKeyDown),
      placeholder: label,
      ref: this.input,
      type: "text",
      value: typedText,
      id: id,
      autoComplete: "off"
    });
  };

  return TextInput;
}(Component);

TextInput.propTypes = {
  /** The initial value for the input */
  defaultValue: PropTypes.string,

  /** The id for input field */
  id: PropTypes.string,

  /** The text for the field's label*/
  label: PropTypes.string.isRequired,

  /** Flag to indicate whether the menu is open. */
  // this is important for handling keyboard events
  menuOpen: PropTypes.bool,

  /** Called with the user-provided input */
  onFocus: PropTypes.func.isRequired,

  /** Called when the input receives focus */
  onChange: PropTypes.func.isRequired,

  /** Called when the user presses the enter key */
  onEnterKey: PropTypes.func.isRequired,

  /** The predicted text to be appended to typedText*/
  predictedText: PropTypes.string
};
export default TextInput;
//# sourceMappingURL=TextInput.js.map